(function() {
  'use strict';
  angular.module('common')
  .filter('capitalize', [function() {
    return function(val) {
      return val ? val.charAt(0).toUpperCase() + val.substr(1) : '';
    };
  }]);
})();
